const HomePageOverlay = () => null;

export default HomePageOverlay;
